import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

import { AuthenticationService } from '@shared/services';

@Injectable({
    providedIn: 'root'
})
export class HomeRedirect implements CanActivate {

    constructor(
        private router: Router,
        private authenticationService: AuthenticationService
    ) {}

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        this.router.navigate(['/membership-card']);
        return true;
        // const member = this.authenticationService.memberValue;
        // if (member) {
        //     this.router.navigate(['/membership-card']);
        //     return true;
        // }

        // this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
        // return false;
    }

}
